var DistanceMeasurementConfiguration = /** @class */ (function () {
    function DistanceMeasurementConfiguration(config) {
        /**
         * Class that determines which icon is used for the button.
         *
         * @Default 'esri-icon-minus'
         */
        this.iconClass = 'esri-icon-polyline';
        /**
         * The threshold distance used by the "auto" mode to switch between planar and geodesic linear computations. The threshold is measured in meters.
         *
         * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-DistanceMeasurement2D-DistanceMeasurement2DViewModel.html#geodesicDistanceThreshold)
         *
         */
        this.geodesicDistanceThreshold = 100000;
        /**
         * Unit system (imperial, metric) or specific unit used for displaying the distance values.  **Possible Values:** metric | imperial | inches | feet | us-feet | yards | miles | nautical-miles | meters | kilometers
         *
         * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-DistanceMeasurement2D-DistanceMeasurement2DViewModel.html#unit)
         */
        this.unit = 'miles';
        if (config) {
            Object.assign(this, config);
        }
    }
    return DistanceMeasurementConfiguration;
}());
export default DistanceMeasurementConfiguration;
export var DistanceMeasureConfigurationConverter = function (value) {
    if (typeof value === 'string') {
        return new DistanceMeasurementConfiguration(JSON.parse(value));
    }
    return value;
};
